import { setWorkerUrl } from 'maplibre-gl'
import maplibreWorkerUrl from 'maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url'

let hasSetWorkerUrl = false

/**
 * Vite can't resolve maplibre-gl's worker via import.meta.url, so this must
 * run before the first Map anywhere. Each map area calls it before
 * constructing its own Map, since it can't assume another area already
 * ran — the actual config write happens only once, on the first call.
 */
export const setUpMaplibreWorker = (): void => {
  if (hasSetWorkerUrl) return
  setWorkerUrl(maplibreWorkerUrl)
  hasSetWorkerUrl = true
}
